<template>
  <div>
    <div class="header">基本信息</div>
    <el-form ref="itemDate" :model="itemDate" :hide-required-asterisk="false">
      <el-form-item label="优惠券名称" label-width="120px">
        <el-input
          size="medium"
          placeholder="请输入优惠券名称"
          style="width: 200px"
          v-model="itemDate.name"
          prop="name"
          disabled
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券id" label-width="120px">
        <el-input
          size="medium"
          style="width: 200px"
          prop="code"
          disabled
          v-model="itemDate.code"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="适用平台" label-width="120px">
        <span v-if="itemDate.source == 1">秒得</span>
        <span v-if="itemDate.source == 2">智租侠</span>
      </el-form-item>
      <el-form-item label="优惠方式" label-width="120px">
        <el-radio-group
          v-model="itemDate.method"
          @change="ChangeMethod"
          disabled
        >
          <el-radio :label="1">满减</el-radio>
          <el-radio :label="2">折扣</el-radio>
          <el-radio :label="3">免息</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="优惠金额"
        v-if="itemDate.method == 1"
        label-width="120px"
      >
        <el-input
          size="medium"
          style="width: 200px"
          disabled
          placeholder="请输入金额（支持小数点）"
          v-model.number="itemDate.quantity"
          type="number"
          min="0"
          @mousewheel.native.prevent
          input="value=value.replace(/[^\d.]/g,'')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="折扣比例"
        v-if="itemDate.method == 2"
        label-width="120px"
      >
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.quantity"
          autocomplete="off"
        ></el-input>
        %
        <span class="huise">注意: 1代表0.1折，99代表9.9折。</span>
      </el-form-item>
      <el-form-item
        label="免息期数"
        v-if="itemDate.method == 3"
        label-width="120px"
      >
        <el-radio-group v-model="itemDate.quantity" disabled>
          <el-radio :label="3">3期</el-radio>
          <el-radio :label="6">6期</el-radio>
          <el-radio :label="12">12期</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="满减条件"
        v-if="itemDate.method == 1"
        label-width="120px"
      >
        金额 > =
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.minimumPrice"
          placeholder="请输入金额（支持小数点）"
          type="number"
          min="0"
          input="value=value.replace(/[^\d.]/g,'')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="折扣条件"
        v-if="itemDate.method == 2"
        label-width="120px"
      >
        金额 > =
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.minimumPrice"
          placeholder="请输入金额（支持小数点）"
          type="number"
          min="0"
          input="value=value.replace(/[^\d.]/g,'')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="最大优惠上限"
        v-if="itemDate.method == 2"
        label-width="120px"
      >
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.quota"
          placeholder="请输入"
          autocomplete="off"
        ></el-input>
        <div class="huise">
          提示:
          超过最大优惠金额将只优惠上限内的部分。比如优惠上限10元，9折券用于200元的商品，此单最多优惠10元，请注意填写券说明
        </div>
      </el-form-item>

      <el-form-item
        label="使用条件"
        v-if="itemDate.method == 3"
        label-width="120px"
      >
        <!-- <el-input size="medium" disabled style="width:200px" v-model.number="itemDate.maximumPrice" placeholder="请输入金额（支持小数点）" 
              autocomplete="off"></el-input> >=
              金额 > =
          <el-input size="medium" disabled style="width:200px" v-model.number="itemDate.minimumPrice" placeholder="请输入金额（支持小数点）" type="number" min="0" 
          input="value=value.replace(/[^\d.]/g,'')"
              autocomplete="off"></el-input> -->
        金额 >=
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.minimumPrice"
          placeholder="请输入金额（支持小数点）"
          type="number"
          min="0"
          input="value=value.replace(/[^\d.]/g,'')"
          autocomplete="off"
        ></el-input>

        <!-- <= -->
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model.number="itemDate.maximumPrice"
          placeholder="请输入金额（支持小数点）"
          input="value=value.replace(/[^\d.]/g,'')"
          type="number"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="发放数量" label-width="120px">
        <el-input
          size="medium"
          style="width: 200px"
          :disabled="edit"
          @mousewheel.native.prevent
          v-model="itemDate.availableCount"
          @input="OnlyZnum(itemDate.availableCount, 'availableCount')"
          placeholder="请输入数量"
          autocomplete="off"
        ></el-input>
        <span class="huise">
          注意：当前优惠券领取数量{{
            itemDate.takeCount
          }},修改发放数量不得低于该优惠券领取量</span
        >
      </el-form-item>
      <el-form-item label="单用户领券数量" label-width="120px">
        <el-input
          size="medium"
          disabled
          style="width: 200px"
          v-model="itemDate.maximumCount"
          placeholder="请输入请输入数量"
          @input="OnlyZnum(itemDate.availableCount, 'availableCount')"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="使用限定"
        label-width="120px"
        v-if="itemDate.method == 1 || itemDate.method == 2"
      >
        <el-switch
          v-model="UseArea.ifMx"
          disabled
          active-text="能与免息券同时使用"
        >
        </el-switch>
        <el-switch
          disabled
          v-model="supportInterestFreeFlag"
          active-text="能用于免息产品"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        label="使用限定"
        label-width="120px"
        v-if="itemDate.method == 3"
      >
        <el-switch
          v-model="UseArea.ifMj"
          disabled
          active-text="能与满减券同时使用"
        >
        </el-switch>
        <el-switch
          v-model="UseArea.ifZk"
          disabled
          active-text="能与折扣券同时使用"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否公开" label-width="120px">
        <el-switch
          v-model="ruleOpenFlag"
          active-text="公开"
          inactive-text="不公开"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="有效期" label-width="120px">
        <el-radio-group v-model="itemDate.validType" disabled>
          <el-radio :label="1"
            ><span>固定日期</span>
            <el-date-picker
              style="margin-bottom: 10px"
              v-model="dataPicker"
              class="picker"
              disabled
              size="medium"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-radio>
          <el-radio :label="2"
            ><span style="width: 60px; display: inline-block">领取后</span
            ><el-input
              disabled
              size="medium"
              style="width: 200px"
              v-model="itemDate.validDays"
              autocomplete="off"
            ></el-input
            >天(含领券当天)</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="关联商品" label-width="120px">
        <el-radio-group v-model="itemDate.useType" disabled>
          <el-radio :label="1">按类目</el-radio>
          <!-- <el-radio :label="2">按品牌</el-radio> -->
          <el-radio :label="3">按商品(自主挑选)</el-radio>
          <el-radio :label="0" v-if="itemDate.method == 1">全场通用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-select v-if="itemDate.useType == 2" v-model="itemDate.ruleScopeList" multiple placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->

      <template v-if="itemDate.useType == 3" disabled>
        <!-- <el-button type="primary"
          size="mini"
          @click.native="openChooseShopDialog">添加商品
          </el-button> -->
        <el-table :data="haslistData" style="width: 100%">
          <el-table-column width="55"> </el-table-column>
          <el-table-column prop="shopName" label="店铺名称"> </el-table-column>
          <el-table-column prop="itemTitle" label="商品名称"> </el-table-column>
          <el-table-column prop="price" label="售价"> </el-table-column>
          <el-table-column prop="stock" label="库存"> </el-table-column>
          <!-- <el-table-column fixed="right"
              align="center"
              label="操作">
            <template slot-scope="scope">
              <el-button type="text"
                  size="mini"
                  @click.native="deleOneofshop(scope.$index)">删除
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </template>
      <el-form-item v-show="itemDate.useType == 1">
        <div class="div-two">
          <p style="background: #eee; margin: 0; text-align: center">
            已选的后台类目
          </p>
          <!-- <el-tree
                  v-loading="loading"
                  :data="hasTreeData"
                  style="padding:2px"
                  node-key="id"
                  show-checkbox
                  ref="origintree"
                  :load="loadNodes"
                  :default-checked-keys="indexs"
                  :props="hasProps"
                  >
                </el-tree> -->
          <el-tree
            :data="hasTreeData"
            :props="hasProps"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
        <!--  <div class="div-two">
              <p style="background:#eee;margin:0;text-align:center;">可选的后台类目</p>
                <el-tree
                  v-loading="loading"
                  :data="data"
                  style="padding:2px"
                  node-key="id"
                  show-checkbox
                  ref="origintree"
                  :load="loadNodes"
                  :default-checked-keys="indexs"
                  :props="affiliatedSystemProps"
                  >
                </el-tree>
            </div>
            <div class="div-two1"><button @click.prevent="Addto">添加</button></div>  
            <div class="div-two2">
                <p style="background:#eee;margin:0;text-align:center;">已选的后台类目</p>
                <el-tree
                  :data="copydata"
                  style="padding:2px"
                  node-key="id"
                  ref="tree"
                  :filter-node-method="filterNode"
                  :props="affiliatedSystemProps"
                  :expand-on-click-node="true">
                  <span  @mouseover=mouseover(data,1) class="custom-tree-node"   @mouseleave= mouseleave(data,1)  slot-scope="{ node, data }">
                    <span >{{node.label}}</span>
                    <span  v-show="data.is_show">
                      <el-button v-show="data.in_show" style="color:#333;" size="mini" type="text"  @click.prevent="deletelist(node,data)"><img style="width:10px;height:10px;" src="../../assets/deletes.png"></el-button>
                    </span>
                  </span>
                </el-tree>
            </div> -->
      </el-form-item>

      <div class="header">其他信息</div>
      <el-form-item label="提醒规则" label-width="120px">
        <el-checkbox-group v-model="checkList" disabled>
          <el-checkbox label="到期前1天"></el-checkbox>
          <el-checkbox label="领取后3天"></el-checkbox>
          <el-checkbox label="到期前3天"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="说明" label-width="120px">
        <el-input
          size="medium"
          style="width: 200px"
          type="textarea"
          v-model="itemDate.ruleExplain"
          disabled
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center">
      <el-button size="small" type="primary" @click="SureSave()"
        >保存
      </el-button>
      <el-button size="small" @click="returnList()">返回 </el-button>
    </div>

    <el-dialog
      title="商品列表"
      top="50px"
      height="400px"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showSpListDialog"
      @close="closeSpListDialog"
    >
      <el-form
        ref="addSpModelObj"
        :model="addSpModelObj"
        :hide-required-asterisk="false"
      >
        <div class="shoplist">
          <span class="listspan">搜索店铺:</span>
          <el-input
            placeholder="请输入内容"
            style="width: 25%; margin-right: 5%"
            prefix-icon="el-icon-search"
            v-model="searchSpParam.shopName"
          >
          </el-input>
          <span class="listspan">搜索商品:</span>
          <el-input
            placeholder="请输入内容"
            style="width: 25%; margin-right: 5%"
            prefix-icon="el-icon-search"
            v-model="searchSpParam.title"
          >
          </el-input>
          <el-button type="primary" size="mini" @click.native="getItemsForAd(1)"
            >搜索
          </el-button>
        </div>
        <template>
          <el-table
            ref="addSpModel"
            :data="shoplistData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="shopName" label="店铺名称">
            </el-table-column>
            <el-table-column prop="itemTitle" label="商品名称">
            </el-table-column>
            <el-table-column prop="price" label="售价"> </el-table-column>
            <el-table-column prop="stock" label="库存"> </el-table-column>
          </el-table>
          <el-pagination
            background
            style="float: right; margin-top: 20px"
            @size-change="handleSizeShopChange"
            @current-change="handleCurrentShopChange"
            :current-page="searchSpParam.pageNum"
            :page-sizes="[10, 15, 20]"
            :page-size="searchSpParam.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="shoptotal"
          ></el-pagination>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showSpListDialog = false"
          >取 消
        </el-button>
        <el-button type="primary" size="small" @click="AddToNewShopOne()"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>
<script>
// import * as couponApi from "./../../api/coupon";
// import * as adApi from "./../../api/adResource";
// import * as shopApi from "./../../api/shop";
// import * as caApi from "./../../api/category";
// import {
//   timeFormat,
//   getDatePickerTime,
//   handleError,
//   decimalReg,
// } from "./../../util/util";
// import showTags from "./../../components/ShowTags";
export default {
  data() {
    return {
      hasTreeData: "",
      dataPicker: [],
      addSpModel: "",
      loading: false,
      reloadSelectFlag: false,
      showSpListDialog: false,
      couponId: "",
      UseArea: {
        ifMj: false, //是否能与满减券同时使用 1
        ifZk: false, //是否能与折扣券同时使用 2
        ifMx: false, //是否能与免息券同时使用 3
      },
      // 搜索商品列表参数
      searchSpParam: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        shopName: "", //店铺关键词
        title: "", //商品名字
        status: 1, //此处只获取上架商品
      },
      itemDate: {
        name: "",
        method: "",
        quantity: "", //优惠数额：满减为额度，折扣为折扣数，免息为期数
        quota: "", //可优惠额度限制
        remindFlag: {
          //提醒规则(多选)
          remind_one: 0, //到期前1天
          remind_two: 0, //领取后3天
          remind_three: 0, //到期前3天
        },
        availableCount: "", //发券总数量
        code: "", //优惠券编码
        startTime: "", //规则有效开始时间
        endTime: "", //规则有效结束时间
        maximumCount: "", //单用户限量
        maximumPrice: "", //商品最大金额
        minimumPrice: "", //商品最小金额
        methodScope: "", //适用范围：格式(1,2,)
        ruleExplain: "", //优惠券规则说明
        ruleOpen: "", //是否公开
        ruleScope: "", //适用范围ID (关联ids)
        supportInterestFree: "", //是否支持免息商品
        useType: "", //适用类型：0全场通用1按类目2按品牌3按商品(自主挑选)
        validType: "", //时效:1绝对时效（领取后XXX-XXX时间段有效)2相对时效（领取后N天有效）
        validDays: "", //自领取之日起有效天数
        validStartTime: "", //validType=1不能为空 使用结束时间
        validEndTime: "", //validType=1不能为空 使用开始时间
      },
      addSpModelObj: {}, //编辑商品模块
      haslistData: "",
      shoplistData: "", //所有商品列表
      multipleSelectionIn: [], //里层
      multipleSelectionOut: [], //外层
      allmultipleSelectionIn: [], //全部已选
      //类目相关
      affiliatedSystemProps: {
        children: "cates",
        label: "name",
      },
      hasProps: {
        children: "childNode",
        label: "name",
      },
      indexs: [], //idList 所有
      node: {},
      data: [], //全部类目
      checkList: [],
      ruleOpenFlag: false,
      supportInterestFreeFlag: false,
      durTimelist: [
        { value: 1, name: "1秒" },
        { value: 2, name: "2秒" },
      ],
    };
  },
  watch: {
    "itemDate.availableCount"(newVal) {
      var rep = /^(([^0][0-9]+|0)$)|^(([1-9]+)$)/;
      if (newVal < 1 || !rep.test(newVal)) {
        this.itemDate.availableCount = "";
      }
    },
    "itemDate.maximumCount"(newVal) {
      var rep = /^(([^0][0-9]+|0)$)|^(([1-9]+)$)/;
      if (newVal < 1 || !rep.test(newVal)) {
        this.itemDate.maximumCount = "";
      }
    },
  },
  created() {
    this.searchParam = this.$route.params.searchParam || "";
    // this.getAllBgCates();
    this.couponId = this.$route.params.id;
    if (this.couponId) {
      this.getCouponDetail();
    }
  },
  methods: {
    //input只能输正整数(大于0)
    OnlyZnum(a, name) {
      a = a.replace(/^0(0+)|[^\d]+/g, "");
      if (a == "0") {
        a = "";
      }
      this.itemDate[name] = a;
    },
    returnList() {
      this.$router.push({
        name: "优惠券配置",
        params: {
          searchParam: this.searchParam,
        },
      });
    },
    ChangeMethod() {
      console.log(1111);
      this.checkList = [];
      this.dataPicker = [];
      this.UseArea = {
        ifMj: false, //是否能与满减券同时使用 1
        ifZk: false, //是否能与折扣券同时使用 2
        ifMx: false, //是否能与免息券同时使用 3
      };
      this.ruleOpenFlag = false;
      this.supportInterestFreeFlag = false;
      this.itemDate.quantity = "";
      this.itemDate.quota = "";
      this.itemDate.availableCount = "";
      this.itemDate.maximumCount = "";
      this.itemDate.maximumPrice = "";
      this.itemDate.minimumPrice = "";
      this.itemDate.methodScope = "";
      this.itemDate.ruleExplain = "";
      this.itemDate.ruleOpen = "";
      this.itemDate.ruleScope = ""; //适用范围ID (关联ids)
      this.itemDate.supportInterestFree = "";
      this.itemDate.useType = "";
      this.itemDate.validType = "";
      this.itemDate.validDays = "";
      this.itemDate.validStartTime = "";
      this.itemDate.validEndTime = "";
      // this.$refs['formData'].resetFields();
    },
    async SureSave() {
      if (this.itemDate.availableCount < this.itemDate.takeCount) {
        this.$message({
          message: "修改发放数量不得低于该优惠券领取量,请重新输入",
          type: "error",
        });
        return false;
      }
      var saveObj = {
        id: this.couponId,
        num: this.itemDate.availableCount || "",
        ruleOpen: this.itemDate.ruleOpen,
      };
      if (this.ruleOpenFlag == true) {
        saveObj.ruleOpen = 0;
      } else {
        saveObj.ruleOpen = 1;
      }
      try {
        this.loading = true;
        let res = await couponApi.updateRule(saveObj);
        this.loading = false;
        if (res.code == "200") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.$router.push({
            name: "优惠券配置",
            params: {
              searchParam: this.searchParam,
            },
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    openChooseShopDialog() {
      this.getItemsForAd();
      this.allmultipleSelectionIn =
        JSON.parse(JSON.stringify(this.haslistData)) || [];
      this.showSpListDialog = true;
    },
    async getItemsForAd(pageNum) {
      try {
        this.loading = true;
        if (pageNum) {
          this.searchSpParam.pageNum = pageNum || 1;
        }
        let res = await adApi.getItemsForAd(this.searchSpParam);
        this.loading = false;
        if (res.code == "200") {
          this.shoplistData = res.data.items;
          this.shoptotal = res.data.total;
          this.setSelectedRow();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    // 商品选择变化（最里层
    handleSelectionChange(val) {
      this.multipleSelectionIn = val;
      this.resolveAllSelection();
    },
    resolveAllSelection() {
      let currentPageData = this.shoplistData; // 当前页所有数据
      let currentPageSelected = this.multipleSelectionIn; // 当前页已选数据
      let currentPageNotSelected = []; // 当前页未选数据

      currentPageData.forEach((item) => {
        var findSelectIndex = currentPageSelected.findIndex(
          (ite) => ite.itemId == item.itemId
        );
        if (findSelectIndex == -1) {
          currentPageNotSelected.push(item);
        }
      });
      // 将当前页已选数据放入所有已选项
      currentPageSelected.forEach((item) => {
        var findSelectIndex = this.allmultipleSelectionIn.findIndex(
          (ite) => ite.itemId == item.itemId
        );
        if (findSelectIndex == -1) {
          this.allmultipleSelectionIn.push(item);
        }
      });
      // 将所有已选项数据中当前页没选择的项移除
      currentPageNotSelected.forEach((item) => {
        var notSelectIndex = this.allmultipleSelectionIn.findIndex(
          (ite) => ite.itemId == item.itemId
        );

        if (notSelectIndex != -1) {
          this.allmultipleSelectionIn.splice(notSelectIndex, 1);
        }
      });
      console.log(this.allmultipleSelectionIn, "all");
    },
    setSelectedRow() {
      // 设置当前页已选项
      var that = this;
      var multipleSelectionIn = [];
      that.shoplistData.forEach((item) => {
        for (var i = 0; i < that.allmultipleSelectionIn.length; i++) {
          if (item["itemId"] == that.allmultipleSelectionIn[i].itemId) {
            that.$nextTick(function() {
              that.$refs.addSpModel.toggleRowSelection(item, true);
              multipleSelectionIn.push(item);
            });
          }
        }
      });
      this.multipleSelectionIn = multipleSelectionIn;
      this.reloadSelectFlag = true;
    },
    // 商品列表每页页数变化
    handleSizeShopChange(val) {
      this.searchSpParam.pageSize = val;
      this.getItemsForAd();
    },
    // 商品列表页码变化
    handleCurrentShopChange(val) {
      this.searchSpParam.pageNum = val;
      this.getItemsForAd();
    },
    //关闭确认商品选择弹窗
    closeSpListDialog() {
      this.$refs["addSpModelObj"].clearValidate();
      this.allmultipleSelectionIn = [];
    },
    AddToNewShopOne() {
      //添加选中商品到第一步商品dialog
      this.showSpListDialog = false;
      this.haslistData = JSON.parse(
        JSON.stringify(this.allmultipleSelectionIn)
      );
      this.allmultipleSelectionIn = [];
    },
    //单个删除商品
    deleOneofshop(index) {
      this.haslistData.splice(index, 1);
    },
    // 获取后台全部类目
    async getAllBgCates() {
      this.data = [];
      try {
        let res = await caApi.getBgCates();
        if (res.code == "200") {
          this.data = JSON.parse(JSON.stringify(res.data));
          // 设置全隐藏
          this.copydata = res.data;
          this.iteration(this.copydata);
          this.newfilter();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        handleError(error);
      }
    },
    // 递归循环隐藏全部
    iteration(data) {
      for (var j = 0; j < data.length; j++) {
        data[j].in_show = false;
        if (data[j].cates != null && data[j].cates.length > 0) {
          this.iteration(data[j].cates);
        }
      }
      // console.log(this.copydata)
    },
    //添加关联
    Addto() {
      this.loading = true;
      let aa = this.$refs.origintree.getCheckedNodes();
      //console.log(aa);
      let objindex = [];
      let ainde = this.indexs;
      aa.forEach((item) => {
        if (item.cates == null) {
          objindex.push(item.id);
        }
      });
      var cindex = ainde.concat(objindex);
      var nData = new Array();
      for (var i = 0; i < cindex.length; i++) {
        if (nData.indexOf(cindex[i]) == -1) {
          nData.push(cindex[i]);
        }
      }
      cindex = nData;
      // 显示
      this.iterationst(this.copydata, cindex);
      this.indexs = cindex;
      this.refreshDateTree(cindex);
    },
    // 添加关联的显示递归循环
    iterationst(data, cindex) {
      for (var j = 0; j < data.length; j++) {
        for (var i = 0; i < cindex.length; i++) {
          if (cindex[i] == data[j].id) {
            data[j].in_show = true;
          }
        }
        if (data[j].cates != null && data[j].cates.length > 0) {
          this.iterationst(data[j].cates, cindex);
        }
      }
    },
    // 添加关联的禁止递归循环
    iterationsts(data, cindex) {
      for (var j = 0; j < data.length; j++) {
        for (var i = 0; i < cindex.length; i++) {
          if (cindex[i] == data[j].id) {
            data[j].disabled = true;
          }
        }
        if (data[j].cates != null && data[j].cates.length > 0) {
          this.iterationsts(data[j].cates, cindex);
        }
      }
    },
    // 添加关联的隐藏递归循环
    iterationsta(data, cindex) {
      for (var j = 0; j < data.length; j++) {
        if (data[j].id == cindex.id) {
          data[j].in_show = false;
        }
        if (data[j].cates != null && data[j].cates.length > 0) {
          this.iterationsta(data[j].cates, cindex);
        }
      }
    },
    async refreshDateTree(cindex) {
      await this.newlist();
      this.iterationsts(this.data, cindex);
      console.log(this.data);
      this.newfilter();
      this.loading = false;
    },
    async newlist() {
      this.data = [];
      try {
        let res = await caApi.getBgCates();
        if (res.code == "200") {
          this.data = JSON.parse(JSON.stringify(res.data));
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        handleError(error);
      }
    },
    // 触发filter
    newfilter() {
      var _this = this;
      _this.loading = true;
      setTimeout(function() {
        //触发filter
        _this.$refs.tree.filter("in_show");
      }, 0);
      _this.loading = false;
    },
    filterNode(value, data, node) {
      return data.in_show;
    },
    mouseleave(data, num) {
      if (num) {
        this.$set(data, "is_show", false);
      } else {
        if (!data.btnflag) {
          this.$set(data, "is_show", false);
          this.Backstagelist = [];
        }
      }
    },
    mouseover(data, num) {
      if (num) {
        this.$set(data, "is_show", true);
      } else {
        if (!data.btnflag) {
          this.$set(data, "is_show", true);
          if (data.parent == 0) {
            this.getdata(data.id);
          }
        }
      }
    },
    // 删除类目关联叶子id
    deletelist(node, data) {
      //console.log(node);
      this.loading = true;
      // 删除隐藏
      this.iterationsta(this.copydata, data);

      var arrylist = this.indexs;
      for (var i = 0; i < arrylist.length; i++) {
        if (arrylist[i] == data.id) {
          arrylist.splice(i, 1);
          break;
        }
      }
      this.indexs = arrylist;
      this.refreshDateTree(arrylist);
    },
    // 获取优惠券详情
    async getCouponDetail() {
      try {
        var Obj = {
          id: this.couponId,
        };
        this.loading = true;
        let res = await couponApi.getCouponDetail(Obj);
        this.loading = false;
        if (res.code == "200") {
          this.itemDate = res.data.couponRuleVO;
          this.dataPicker = [];
          this.checkList = [];
          if (this.itemDate.ruleOpen == 1) {
            this.ruleOpenFlag = false;
          } else {
            this.ruleOpenFlag = true;
          }
          if (this.itemDate.method == 3) {
            this.itemDate.quantity = Number(this.itemDate.quantity);
          }
          if (this.itemDate.remindFlag) {
            if (this.itemDate.remindFlag.remind_one == 1) {
              this.checkList.push("到期前1天");
            }
            if (this.itemDate.remindFlag.remind_two == 1) {
              this.checkList.push("领取后3天");
            }
            if (this.itemDate.remindFlag.remind_three == 1) {
              this.checkList.push("到期前3天");
            }
          }
          if (this.itemDate.validType == 1) {
            this.dataPicker[0] = res.data.couponRuleVO.validStartTime || "";
            this.dataPicker[1] = res.data.couponRuleVO.validEndTime || "";
          }
          if (res.data.couponRuleVO.ruleScope) {
            var ssList = res.data.couponRuleVO.ruleScope.split(",");
            ssList.pop();
            this.itemDate.ruleScopeList = ssList;
          }
          this.hasTreeData = res.data.ruleScopeList;
          if (res.data.couponRuleVO.useType == 3) {
            this.getHasList();
          } else if (res.data.couponRuleVO.useType == 2) {
            if (res.data.ruleScopeList && res.data.ruleScopeList.length > 0) {
              this.hasTreeData = res.data.ruleScopeList;
            }
          }
          if (this.itemDate.supportInterestFree == 1) {
            this.supportInterestFreeFlag = false;
          } else {
            this.supportInterestFreeFlag = true;
          }
          this.UseArea = {
            ifMj: false, //是否能与满减券同时使用 1
            ifZk: false, //是否能与折扣券同时使用 2
            ifMx: false, //是否能与免息券同时使用 3
          };
          if (this.itemDate.methodScope) {
            if (this.itemDate.methodScope.indexOf("1") != -1) {
              this.UseArea.ifMj = true;
            }
            if (this.itemDate.methodScope.indexOf("2") != -1) {
              this.UseArea.ifZk = true;
            }
            if (this.itemDate.methodScope.indexOf("3") != -1) {
              this.UseArea.ifMx = true;
            }
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
    },
    //获取已关联的商品列表
    async getHasList(items) {
      this.haslistData = [];
      var itemIds = "";
      if (this.itemDate.ruleScope) {
        itemIds = this.itemDate.ruleScope;
        itemIds = itemIds.substring(0, itemIds.length - 1);
      }
      var param = new FormData();
      param.append("itemIds", itemIds); // 文件对象
      try {
        this.loading = true;
        let res = await adApi.getIndexModelItems(param);
        this.loading = false;
        if (res.code == "200") {
          this.haslistData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      } catch (error) {
        this.loading = false;
        handleError(error);
      }
      console.log(this.haslistData);
    },
  },
};
</script>
<style lang="stylus" scoped>
@import './../../styl/variables.styl';
@import './../../styl/common.styl';

.huise {
  color: #989595;
}

.header {
  font-size: 18px;
  padding: 10px;
}

.el-textarea >>> .el-textarea__inner {
  width: 400px;
  height: 100px;
}

.div-two {
  width: 300px;
  margin-left: 30px;
  float: left;
  height: 400px;
  overflow: auto;
  border: 1px solid #eee;
}

.div-two1 {
  position: relative;
  float: left;
  width: 100px;
  height: 400px;

  button {
    border: 1px solid #eee;
    margin: 2px;
    outline: none;
    -webkit-appearance: none;
    text-align: center;
    border-radius: 5px;
    position: absolute;
    top: 50%;
    background: none;
    margin-left: 35%;
  }
}

.div-two2 {
  float: left;
  width: 300px;
  height: 400px;
  overflow: auto;
  border: 1px solid #eee;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
  -webkit-appearance: textfield;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
